// extracted by mini-css-extract-plugin
export default {"Checkout":"Checkout_Checkout__pcyjG","checkoutForm":"Checkout_checkoutForm__gwohr","PaymentSection":"Checkout_PaymentSection__m6yoa","Products":"Checkout_Products__QsdiJ"};